export default [
    {
        path: '/login',
        name: 'LoginUsuario',
        component: () => import('@/views/LoginUsuario.vue'),
        meta: { onlyGuest: true }
    },
    {
        path: '/cadastro',
        name: 'CadastroUsuario',
        component: () => import('@/views/CadastroUsuario.vue'),
        meta: { onlyGuest: true }
    },
    {
        path: '/recuperarsenha',
        name: 'RecuperarSenha',
        component: () => import('@/views/RecuperarSenha.vue'),
        meta: { onlyGuest: true }
    }
]
